import { normalizeOverlayPath } from "@/lib/global-overlays";

export type MobileNavKey = "today" | "ask" | "journey";

const NAV_MATCHERS: Record<MobileNavKey, readonly string[]> = {
  today: ["/panchang", "/my-panchang", "/daily-horoscope", "/weekly-rashifal"],
  ask: ["/ai-astrologer", "/free-astrology-chat", "/chat"],
  journey: ["/account", "/free-kundali", "/kundali"],
};

function withoutLocale(pathname: string): string {
  return pathname === "/hi" ? "/" : pathname.replace(/^\/hi(?=\/)/, "");
}

export function isHindiMobileJourney(pathname: string): boolean {
  const path = normalizeOverlayPath(pathname);
  return path === "/hi" || path.startsWith("/hi/");
}

export function isMobileNavItemActive(pathname: string, key: MobileNavKey): boolean {
  const path = withoutLocale(normalizeOverlayPath(pathname));
  return NAV_MATCHERS[key].some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export function mobileNavKeyForPath(pathname: string): MobileNavKey | null {
  return (
    (Object.keys(NAV_MATCHERS) as MobileNavKey[]).find((key) =>
      isMobileNavItemActive(pathname, key)
    ) ?? null
  );
}
